'use strict';

var _ = require('underscore');
var STATIC = require('js/lib/components/CustomMaker/statics');
var swUtils = require('js/lib/sw-utils');

function filterUnusedVarsForRealtimeJs(data) {
  data = swUtils.cloneDataObject(data);

  delete data.imageCenter;
  delete data.imageHotspotId;
  delete data.imageLocalRotation;
  delete data.imageNormal;
  delete data.imageWidth;
  delete data.modelRotation;
  delete data.textCenter;
  delete data.textHotspotId;
  delete data.textLocalRotation;
  delete data.textNormal;
  delete data.textWidth;

  if(data.hasOwnProperty('imagepos0') && data.imagepos0){
    let imagePosition = data.imagepos0;

    imagePosition.point   = _.map(imagePosition.point, point => (point || 0));
    imagePosition.normal  = _.map(imagePosition.normal, normal => (normal || 0));

    data.imagepos0 = imagePosition;
  }

  if(data.hasOwnProperty('imagepos1') && data.imagepos1){
    let imagePosition = data.imagepos1;

    imagePosition.point   = _.map(imagePosition.point, point => (point || 0));
    imagePosition.normal  = _.map(imagePosition.normal, normal => (normal || 0));

    data.imagepos1 = imagePosition;
  }

  return data;
}

function mapModelDataTOViewerDataText(viewerData, hotspot) {
	if(!_.isUndefined(hotspot.hotspotId)) { viewerData.textHotspotId = hotspot.hotspotId; }
	if(!_.isUndefined(hotspot.text)) { viewerData.text = hotspot.text; }
	if(!_.isUndefined(hotspot.engrave_depth)) { viewerData.engraveDepth = hotspot.engrave_depth; }
	if(hotspot.hotspot && !_.isUndefined(hotspot.hotspot[0])) { viewerData.textpos0 = hotspot.hotspot[0]; }
	if(hotspot.hotspot && !_.isUndefined(hotspot.hotspot[1])) { viewerData.textpos1 = hotspot.hotspot[1]; }
	if(!_.isUndefined(hotspot.height)) { viewerData.textHeight = hotspot.height; }
	if(!_.isUndefined(hotspot.width)) { viewerData.textWidth = hotspot.width; }
	if(!_.isUndefined(hotspot.center)) { viewerData.textCenter = hotspot.center; }
	if(!_.isUndefined(hotspot.local_rotation)) { viewerData.textLocalRotation = hotspot.local_rotation; }
	if(!_.isUndefined(hotspot.normal)) { viewerData.textNormal = hotspot.normal; }
	if(!_.isUndefined(hotspot.font)) { viewerData.font = hotspot.font; }
	if(!_.isUndefined(hotspot.text_alignment)) { viewerData.textAlignment = hotspot.text_alignment; }
	if(!_.isUndefined(hotspot.tracking)) { viewerData.textTracking = hotspot.tracking; }
	if(!_.isUndefined(hotspot.depth)) { viewerData.textDepth = hotspot.depth; }
	if(!_.isUndefined(hotspot.font_size)) { viewerData.textFontSize = hotspot.font_size; }
	if(!_.isUndefined(hotspot.line_height)) { viewerData.textLineHeight = hotspot.line_height; }

	return viewerData;
}

function mapModelDataTOViewerDataImage(viewerData, hotspot) {
	if(!_.isUndefined(hotspot.hotspotId)) { viewerData.imageHotspotId = hotspot.hotspotId; }
	if(!_.isUndefined(hotspot.image)) { viewerData.image = hotspot.image; }
	if(!_.isUndefined(hotspot.engrave_depth)) { viewerData.engraveDepth = hotspot.engrave_depth; }
	if(hotspot.hotspot && !_.isUndefined(hotspot.hotspot[0])) { viewerData.imagepos0 = hotspot.hotspot[0]; }
	if(hotspot.hotspot && !_.isUndefined(hotspot.hotspot[1])) { viewerData.imagepos1 = hotspot.hotspot[1]; }
	if(!_.isUndefined(hotspot.x_pan)) { viewerData.imageX = hotspot.x_pan; }
	if(!_.isUndefined(hotspot.y_pan)) { viewerData.imageY = hotspot.y_pan; }
	if(!_.isUndefined(hotspot.height)) { viewerData.imageHeight = hotspot.height; }
	if(!_.isUndefined(hotspot.width)) { viewerData.imageWidth = hotspot.width; }
	if(!_.isUndefined(hotspot.center)) { viewerData.imageCenter = hotspot.center; }
	if(!_.isUndefined(hotspot.local_rotation)) { viewerData.imageLocalRotation = hotspot.local_rotation; }
	if(!_.isUndefined(hotspot.normal)) { viewerData.imageNormal = hotspot.normal; }
	if(!_.isUndefined(hotspot.mapping)) { viewerData.imageMapping = hotspot.mapping; }
	if(!_.isUndefined(hotspot.angle)) { viewerData.imageAngle = hotspot.angle; }
	if(!_.isUndefined(hotspot.depth)) { viewerData.imageDepth = hotspot.depth; }
	if(!_.isUndefined(hotspot.scale)) { viewerData.imageScale = hotspot.scale; }
	if(!_.isUndefined(hotspot.resolution)) { viewerData.resolution = hotspot.resolution; }

	return viewerData;
}

function formatModelDataForViewer(modelData, forRealtime) {
	var viewerData = {
		textpos0: null,
		textpos1: null,
		imagepos0: null,
		imagepos1: null
	};

	function reduceToFormViewerFormat (viewerData, hotspot) {
		if(hotspot.type === STATIC.TEXT) {
			viewerData = mapModelDataTOViewerDataText(viewerData, hotspot);
		} else if(hotspot.type === STATIC.IMAGE) {
			viewerData = mapModelDataTOViewerDataImage(viewerData, hotspot);
		}
		return viewerData;
	}

	viewerData = _.reduce(modelData.hotspots || [], reduceToFormViewerFormat, viewerData);

	if(forRealtime) { viewerData = filterUnusedVarsForRealtimeJs(viewerData); }

	if(!_.isUndefined(viewerData.textFontSize) || !_.isUndefined(viewerData.textLineHeight)) {
		viewerData.textFormatType = STATIC.TEXT_FORMAT_MULTI;
	}

	if(modelData.model) { viewerData.model = modelData.model; }
	if(modelData.resolution) { viewerData.resolution = modelData.resolution; }
	if(modelData.modelRotation) { viewerData.modelRotation = modelData.modelRotation; }

	return viewerData; 
}

function normalizeHotspotIdFromViewer(id) {
	if(id.replace) {
		return parseInt(id.replace('hotspot_', ''), 10);
	} else {
		return id;
	}
}

function stripViewerPrefix(viewerData) {
	return _.reduce(viewerData, function(cleanData, value, index) {
		var cleanIndex = index.replace(STATIC.SHAPE_JS_PREFIX, '');
		cleanData[cleanIndex] = value;
		return cleanData;
	}, {});
}

function formatViewerDataForModel(viewerData) {
	var modelData = {
		hotspots: []
	};
	var text, image;

	if(viewerData.model) { modelData.model = viewerData.model; }
	if(viewerData.resolution) { modelData.resolution = viewerData.resolution; }

	_.each(viewerData, function(value, key) {

		image = (key[0] === 'i' || key[0] === 'r') && _.isUndefined(image) ? { type: STATIC.IMAGE} : image;
		text = (key[0] === 't' || key[0] === 'e') && _.isUndefined(text) ? { type: STATIC.TEXT } : text;

		switch(key) {
			case 'text':
				text.text = value;
				break;
			case 'textHotspotId':
				text.hotspotId = normalizeHotspotIdFromViewer(value);
				break;
			case 'engraveDepth':
				text.engrave_depth = value;
				image.engrave_depth = value;
				break;
			case 'textpos0':
				text.hotspot = text.hotspot || [];
				text.hotspot[0] = value;
				break;
			case 'textpos1':
				text.hotspot = text.hotspot || [];
				text.hotspot[1] = value;
				break;
			case 'textHeight':
				text.height = value;
				break;
			case 'textWidth':
				text.width = value;
				break;
			case 'textCenter':
				text.center = value;
				break;
			case 'textNormal':
				text.normal = value;
				break;
			case 'textLocalRotation':
				text.local_rotation = value;
				break;
			case 'font':
				text.font = value;
				break;
			case 'textAlignment':
				text.text_alignment = value;
				break;
			case 'textTracking':
				text.tracking = value;
				break;
			case 'textDepth':
				text.depth = value;
				break;
			case 'textFontSize':
				text.font_size = value;
				break;
			case 'textLineHeight':
				text.line_height = value;
				break;
			case 'image':
				image.image = value;
				break;
			case 'imageHotspotId':
				image.hotspotId = normalizeHotspotIdFromViewer(value);
				break;
			case 'imagepos0':
				image.hotspot = image.hotspot || [];
				image.hotspot[0] = value;
				break;
			case 'imagepos1':
				image.hotspot= image.hotspot || [];
				image.hotspot[1] = value;
				break;
			case 'imageHeight':
				image.height = value;
				break;
			case 'imageWidth':
				image.width = value;
				break;
			case 'imageCenter':
				image.center = value;
				break;
			case 'imageNormal':
				image.normal = value;
				break;
			case 'imageLocalRotation':
				image.local_rotation = value;
				break;
			case 'imageMapping':
				image.mapping = value;
				break;
			case 'imageDepth':
				image.depth = value;
				break;
			case 'imageX':
				image.x_pan = value;
				break;
			case 'imageY':
				image.y_pan = value;
				break;
			case 'imageAngle':
				image.angle = value;
				break;
			case 'imageScale':
				image.scale = value;
				break;
			// case 'resolution':
			// 	image.resolution = value;
			// 	break;
		}
	});

	if(_.isObject(image) && image.hotspotId) {
		modelData.hotspots.push(image); 
	}
	if(_.isObject(text) && text.hotspotId) {
		modelData.hotspots.push(text); 
	}

	return modelData;
}

module.exports = {
	filterUnusedVarsForRealtimeJs: filterUnusedVarsForRealtimeJs,
	formatModelDataForViewer: formatModelDataForViewer,
	formatViewerDataForModel: formatViewerDataForModel,
	stripViewerPrefix: stripViewerPrefix
};
